import { render, staticRenderFns } from "./OfficeTransfer.vue?vue&type=template&id=101634dc&scoped=true&"
import script from "./OfficeTransfer.vue?vue&type=script&lang=js&"
export * from "./OfficeTransfer.vue?vue&type=script&lang=js&"
import style0 from "./OfficeTransfer.vue?vue&type=style&index=0&id=101634dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101634dc",
  null
  
)

export default component.exports